import styled from "styled-components";
import tw from "twin.macro";

const buttonColors = {
  teal: "#4f8884",
  orange: "#A4400A",
};

const GradientButton = styled.a`
  ${tw`inline-flex items-center justify-center rounded-full text-center`}
  position: relative;
  overflow: hidden;
  color: #fff;
  background: linear-gradient(
        ${({ $variant }) => buttonColors[$variant] || buttonColors.orange},
        ${({ $variant }) => buttonColors[$variant] || buttonColors.orange}
      )
      padding-box,
    linear-gradient(90deg, #a98f39 0%, #e5d9a6 52%, #a98f39 100%) border-box;
  border: ${({ $borderWidth }) => $borderWidth || "2px"} solid transparent;
  box-shadow: 0 12px 16px rgba(0, 0, 0, 0.2);
  font-family: "Montserrat", sans-serif;
  letter-spacing: 0;
  text-decoration: none;
  font-size: 16px;
  transition: transform 160ms ease, box-shadow 160ms ease, filter 160ms ease;

  &:hover {
    filter: brightness(1.03);
  }

  &:active {
    transform: translateY(2px) scale(0.99);
    box-shadow: 0 7px 10px rgba(0, 0, 0, 0.18);
  }
`;

export default GradientButton;
